export const insertThousandsDots = number => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

export const dotToComma = number => number.toString().replace('.', ',');
